import BaseAPI from "../base";
import { getStorageExpire, setStorageExpire } from "@/utils/utils";
import { CONFIG_STORAGE } from "@/constants/storage";
import hisService from "@/apis/his/index";

class CuotomerService extends BaseAPI {
  // HIS患者查询
  hisPatientSearch(params) {
    return this.post({
      url: "/YuanHe/WorkCustomComponents/HisPatientSearch",
      data: params,
    });
  }

  // HIS患者新增
  hisPatientAdd(params) {
    return this.post({
      url: "/YuanHe/WorkCustomComponents/HisPatientAdd",
      data: params,
    });
  }

  // HIS患者编辑
  hisPatientEdit(params) {
    return this.post({
      url: "/YuanHe/WorkCustomComponents/HisPatientEdit",
      data: params,
    });
  }

  // HIS患者相关枚举
  hisPatientEnums(params) {
    // return this.post({
    //   url: "/YuanHe/WorkCustomComponents/HisPatientEnums",
    //   data: params,
    // });
    return new Promise((resolve) => {
      const result = getStorageExpire(CONFIG_STORAGE.HIS_ENUM);
      const version = CONFIG_STORAGE.currentVersion;
      if (result && result.version >= version) resolve(result);
      else {
        this.post({
          url: "/YuanHe/WorkCustomComponents/HisPatientEnums",
          data: params,
        }).then((res) => {
          Object.keys(res).forEach((key) => {
            const item = res[key];
            res[`${key}Map`] = {};
            item.forEach((option) => {
              res[`${key}Map`][option.Value] = option.Text;
            });
          });
          res.version = version;
          setStorageExpire(CONFIG_STORAGE.HIS_ENUM, res, 60 * 24);
          resolve(res);
        });
      }
    });
  }

  // 医生查询
  hisDoctorSearch(params) {
    return this.post({
      url: "/YuanHe/WorkCustomComponents/DoctorSearch",
      data: params,
    });
  }

  // // 推荐渠道查询
  // scrmAccounts(params) {
  //   return this.post({
  //     url: "/YuanHe/WorkCustomComponents/ScrmAccounts",
  //     data: params,
  //   });
  // }
  // 推荐渠道查询
  scrmAccounts(params) {
    const data = {
      msg_id: "",
      access_token: "Circle_Health_761C12E9",
      app_key: "",
      sign: "",
      msg_type: "OutpatientDepartment.BaesInfoCore.FindChannel",
      logistics_interface: JSON.stringify({
        saleUserId: 0,
        UnitId: 0,
        channelName: params.filter || "",
      }),
    };
    return hisService.mainMethod(data).then((res) => {
      res.forEach((item) => {
        item.account_id = item.channel_id;
        item.account_name = item.channel_name;
        item.user_id = item.channel_manager_id;
        item.user_name = item.channel_manager;
      });
      return res;
    });
  }
}

export default new CuotomerService();
